<template>
	<popup class="code_popup" :title="insertCode?'Custom HTML':'Custom CSS / JS'" @close="closeThisPopup">
		<template v-slot:content>
			<ul id="tabs-nav" class="" v-if="!insertCode">
				<li>
					<a :class="{'active' : tabActive===1}" @click="setActiveTab(1)">Custom CSS</a>
				</li>
			</ul>
			<div class="code_popup_editor_wrpr " v-if="insertCode">
				<prism-editor class="my-editor" v-model="rawCode" :highlight="highlighter" line-numbers
				              :tabSize='4'></prism-editor>
			</div>
			<div class="js-sector" v-else>
				<!-- <h3 class="code-title">Custom CSS</h3> -->
				<div class="code_popup_editor_wrpr" v-show="tabActive == 1">
					<prism-editor class="my-editor" v-model="rawCodeCSS" :highlight="highlighterCss" line-numbers
					              :tabSize='4'></prism-editor>
				</div>
			</div>
		</template>
		<template v-slot:actions>
			<v-button @click="save" label="Save changes" />
			<v-button @click="closeThisPopup" border label="Cancel" />
		</template>
	</popup>
</template>

<script>
import {mapGetters} from 'vuex';
import spacer from "@/modules/page-editor/src/components/generator/Spacer.vue";
import button from "@/modules/page-editor/src/components/generator/Button.vue";
import headline from "@/modules/page-editor/src/components/generator/Headline.vue";
import paragraph from "@/modules/page-editor/src/components/generator/Paragraph.vue";
import image from "@/modules/page-editor/src/components/generator/Image.vue";
import video from "@/modules/page-editor/src/components/generator/Video.vue";
import link from "@/modules/page-editor/src/components/generator/Link.vue";
import social from "@/modules/page-editor/src/components/generator/Social.vue";
import menu from "@/modules/page-editor/src/components/generator/Menu.vue";
import timer from "@/modules/page-editor/src/components/generator/Timer.vue";
import custom from "@/modules/page-editor/src/components/generator/Custom.vue";
import progressBar from "@/modules/page-editor/src/components/generator/ProgressBar.vue";
import productList from "@/modules/page-editor/src/components/generator/ProductList.vue";
import formElement from "@/modules/page-editor/src/components/generator/FormElement.vue";
import paymentForm from "@/modules/page-editor/src/components/generator/PaymentForm.vue";
import twoStepForm from "@/modules/page-editor/src/components/generator/TwoStepForm.vue";

import {PrismEditor} from 'vue-prism-editor';
import 'vue-prism-editor/dist/prismeditor.min.css';

import {highlight, languages} from 'prismjs/components/prism-core';
import 'prismjs/components/prism-clike';
import 'prismjs/components/prism-markup';
import 'prismjs/themes/prism-tomorrow.css';
import 'prismjs/components/prism-javascript';
import 'prismjs/components/prism-css';

import Popup from '@/components/base/popup';
import VButton from '@/components/base/v-button';

export default {
	name: 'CodePopup',
	components: {
		PrismEditor,
		Popup,
		VButton,
		emailSpacer: spacer,
		emailButton: button,
		emailHeadline: headline,
		emailParagraph: paragraph,
		emailImage: image,
		emailVideo: video,
		emailLink: link,
		emailSocial: social,
		emailMenu: menu,
		emailTimer: timer,
		emailCustom: custom,
		emailProgressBar: progressBar,
		emailProductList: productList,
		emailFormElement: formElement,
		emailPaymentForm: paymentForm,
		emailTwoStepForm: twoStepForm,
	},
	props: {
		insertCode: {
			type: Boolean,
			default: false,
		},
		html: {
			type: String,
			default: '',
		},
	}, // ['insertCode', 'html'],
	data() {
		return {
			rawCode: '',
			rawCodeCSS: '',
			showMail: false,
			tabActive: 1,
		}
	},
	computed: {
		...mapGetters(['email_findOne', 'email_findChild']),
		getCSS() {
			if (this.$store.state.email.customCode.css !== '') {
				return this.$store.state.email.customCode.css
			}
			return '/* CSS */\n'
		},
		view() {
			return this.$store.state.page.view
		},
		page() {
			return this.$store.state.page.page
		},
	},
	methods: {
		highlighter(code) {
			return highlight(code, languages.markup);
		},
		highlighterCss(code) {
			return highlight(code, languages.css);
		},
		save() {
			if (this.insertCode) {
				this.$emit('done', this.rawCode);
			} else
				this.$emit('done', {
					css: this.rawCodeCSS,
				});
			},
		closeThisPopup() {
			this.$emit('close');
		},
		setActiveTab(tabActiveNumber) {
			this.tabActive = tabActiveNumber;
		}
	},
	mounted() {
		if (!this.insertCode) {
			this.rawCodeCSS = this.getCSS;
		} else
			this.rawCode = this.html;

		let containers = document.querySelectorAll('.code_popup .my-editor .prism-editor__container');
		containers.forEach(x => {
			x.classList.add('scroll-x', 'scroll')
		})
	},
	created() {

	}
}
</script>

<style lang="scss">
.code_popup {
	cursor: default;
	@include default-font();

	.popup {
		min-height: 300px;
	}
	.content {
		padding: 0;
	}
	.actions {
	}
	#tabs-nav {
		margin-bottom: 5px;
	}
	//.prism-editor-wrapper .prism-editor__editor,
	//.prism-editor-wrapper .prism-editor__textarea {
	//	white-space: pre !important;
	//	color: black;
	//}
	.prism-editor-wrapper .prism-editor__container {
		min-height: 200px;
		//overflow-x: scroll !important;
	}
	.raw-code {
		display: block;
		width: 100%;
		padding: 50px;
		background: #000;
		color: black;
	}

	.my-editor {
		font-family: Fira code, Fira Mono, Consolas, Menlo, Courier, monospace;
		font-size: 14px;
		line-height: 1.5;
		padding: 5px;
		border-radius: 3px;
		border: 1px solid #dcdcdc;
		background-color: #efefef;
	}

	.prism-editor__textarea:focus {
		outline: none;
	}

	.code-title {
		margin: 5px 25px;
	}
}

</style>
<style lang="scss" scoped>
.code_popup {

	ul#tabs-nav {
		display: flex;
		align-items: center;
		text-align: center;
		border-bottom: 1px solid #E4E6F1;

		li {
			cursor: pointer;
			flex: auto;
			height: 100%;
			border-bottom: 3px solid transparent;
			transition: .2s;
			position: relative;
			margin: 0 15px;
		}
		a {
			font-size: 13px;
			letter-spacing: 0.02em;
			color: #636A7B;
			width: 100%;
			height: 100%;
			display: flex;
			justify-content: center;
			padding: 8px 0;
			border-radius: 6px;
			&:hover {
				background: #f4f5f8;
			}
			&.active {
				background: #dce9ff;
				color: #116dff;
			}
		}
	}
}
</style>
